(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Reviews"] && !Shopify.designMode) return;
  try {
    
class SFRTestimonialSlider {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;

    // Core elements
    this.track = this.container.querySelector('.sfr-track');
    this.cards = this.container.querySelectorAll('.sfr-card');
    this.dotsContainer = this.container.querySelector('.sfr-dots');
    this.dots = this.dotsContainer ? this.dotsContainer.querySelectorAll('.sfr-dot') : [];
    this.prevButton = this.container.querySelector('.sfr-prev-arrow');
    this.nextButton = this.container.querySelector('.sfr-next-arrow');

    if (!this.track || this.cards.length === 0) return;

    // State variables
    this.currentIndex = 0;
    this.totalSlides = this.cards.length;
    this.slidesPerView = this.getSlidesPerView();
    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.animationID = 0;
    this.autoplayInterval = null;
    this.touchStartTime = 0;
    this.touchEndTime = 0;
    this.touchStartIdentifier = null;

    // Settings
    this.settings = {
      autoplay: this.container.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.container.dataset.autoplaySpeed) * 1000 || 5000,
      dragThreshold: 100, // Minimum distance in px to trigger slide change
      swipeThreshold: 300 // Maximum time in ms for a swipe to be considered valid
    };

    this.init();
  }

  getSlidesPerView() {
    return window.innerWidth < 768 ? 1 : 3;
  }

  updateSlidesPerView() {
    const oldSlidesPerView = this.slidesPerView;
    this.slidesPerView = this.getSlidesPerView();

    if (oldSlidesPerView !== this.slidesPerView) {
      this.cards.forEach(card => {
        card.style.flexBasis = `${100 / this.slidesPerView}%`;
        card.style.maxWidth = `${100 / this.slidesPerView}%`;
      });
      this.goToSlide(this.currentIndex, false);
    } else {
      this.updateArrows();
      this.updateDots();
    }
  }

  goToSlide(index, animate = true) {
    if (this.totalSlides <= this.slidesPerView) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = Math.max(0, Math.min(index, this.totalSlides - this.slidesPerView));
    }

    const newTranslate = this.currentIndex * (-100 / this.slidesPerView);
    this.currentTranslate = newTranslate;
    this.prevTranslate = newTranslate;

    if (animate) {
      this.track.style.transition = 'transform 0.5s ease';
    } else {
      this.track.style.transition = 'none';
    }
    this.setTransform();
    this.updateDots();
    this.updateArrows();

    if (!animate) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.track.style.transition = 'transform 0.5s ease';
        });
      });
    }

    this.resetAutoplay();
  }

  setTransform() {
    this.track.style.transform = `translateX(${this.currentTranslate}%)`;
  }

  updateDots() {
    if (!this.dots || this.dots.length === 0) return;

    let activeDotIndex = this.currentIndex;
    if (this.totalSlides <= this.slidesPerView) {
      activeDotIndex = 0;
    }

    this.dots.forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.index);
      if (dotIndex === activeDotIndex) {
        dot.classList.add('sfr-dot-active');
        dot.style.backgroundColor = '#FF6B00';
      } else {
        dot.classList.remove('sfr-dot-active');
        dot.style.backgroundColor = '#ccc';
      }
    });
  }

  updateArrows() {
    if (this.prevButton) {
      this.prevButton.disabled = this.currentIndex === 0;
    }
    if (this.nextButton) {
      const lastPossibleIndex = Math.max(0, this.totalSlides - this.slidesPerView);
      this.nextButton.disabled = this.currentIndex === lastPossibleIndex || this.totalSlides <= this.slidesPerView;
    }
  }

  touchStart(event) {
    this.stopAutoplay();
    
    // For touch events, store the identifier to track the correct touch point
    if (event.type === 'touchstart') {
      if (event.touches.length > 1) return; // Ignore multi-touch
      this.touchStartIdentifier = event.touches[0].identifier;
    }
    
    this.touchStartTime = Date.now();
    this.startX = this.getPositionX(event);
    this.isDragging = true;
    this.track.style.transition = 'none';
    this.animationID = requestAnimationFrame(this.animation.bind(this));
    this.track.style.cursor = 'grabbing';
  }

  touchMove(event) {
    if (!this.isDragging) return;
    
    // For touch events, ensure we're tracking the same touch point
    if (event.type === 'touchmove') {
      const touchIndex = Array.from(event.changedTouches).findIndex(
        touch => touch.identifier === this.touchStartIdentifier
      );
      if (touchIndex === -1) return;
    }
    
    const currentPosition = this.getPositionX(event);
    const dragDistance = currentPosition - this.startX;
    const containerWidth = this.track.offsetWidth;
    const dragPercent = (dragDistance / containerWidth) * 100;
    
    // Resistance at edges
    if ((this.currentIndex === 0 && dragDistance > 0) || 
        (this.currentIndex >= this.totalSlides - this.slidesPerView && dragDistance < 0)) {
      this.currentTranslate = this.prevTranslate + (dragPercent * 0.3); // Add resistance
    } else {
      this.currentTranslate = this.prevTranslate + dragPercent;
    }
  }

  touchEnd(event) {
    if (!this.isDragging) return;
    
    // For touch events, ensure we're ending the same touch point
    if (event.type === 'touchend' || event.type === 'touchcancel') {
      const touchIndex = Array.from(event.changedTouches).findIndex(
        touch => touch.identifier === this.touchStartIdentifier
      );
      if (touchIndex === -1) return;
      this.touchStartIdentifier = null;
    }
    
    this.touchEndTime = Date.now();
    const touchDuration = this.touchEndTime - this.touchStartTime;
    
    cancelAnimationFrame(this.animationID);
    this.isDragging = false;
    this.track.style.cursor = 'grab';
    
    const movedByPercent = this.currentTranslate - this.prevTranslate;
    const thresholdPercent = (100 / this.slidesPerView) * 0.2;
    
    // Only register as a swipe if fast enough
    if (touchDuration < this.settings.swipeThreshold) {
      if (movedByPercent < -thresholdPercent && this.currentIndex < this.totalSlides - this.slidesPerView) {
        this.currentIndex += 1;
      } else if (movedByPercent > thresholdPercent && this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    } else {
      // Slower drag needs to move further
      const largerThreshold = thresholdPercent * 2;
      if (movedByPercent < -largerThreshold && this.currentIndex < this.totalSlides - this.slidesPerView) {
        this.currentIndex += 1;
      } else if (movedByPercent > largerThreshold && this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    }

    this.track.style.transition = 'transform 0.5s ease';
    this.goToSlide(this.currentIndex);
    this.resetAutoplay();
  }

  getPositionX(event) {
    if (event.type.includes('mouse')) {
      return event.pageX;
    }
    
    // For touchstart and touchmove
    if (event.type === 'touchstart') {
      return event.touches[0].clientX;
    }
    
    // For touchend and touchmove, find the right touch point
    const touchIndex = Array.from(event.changedTouches).findIndex(
      touch => touch.identifier === this.touchStartIdentifier
    );
    
    if (touchIndex !== -1) {
      return event.changedTouches[touchIndex].clientX;
    }
    
    return 0;
  }

  animation() {
    this.setTransform();
    if (this.isDragging) requestAnimationFrame(this.animation.bind(this));
  }

  startAutoplay() {
    if (!this.settings.autoplay || this.totalSlides <= this.slidesPerView) return;
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      let nextIndex = this.currentIndex + 1;
      if (nextIndex > this.totalSlides - this.slidesPerView) {
        nextIndex = 0;
      }
      this.goToSlide(nextIndex);
    }, this.settings.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  // Memory management
  destroy() {
    this.stopAutoplay();
    
    // Remove event listeners
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.prevClickHandler);
    }
    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.nextClickHandler);
    }
    
    if (this.dots) {
      this.dots.forEach(dot => {
        dot.removeEventListener('click', dot.clickHandler);
      });
    }
    
    this.track.removeEventListener('mousedown', this.mouseDownHandler);
    this.track.removeEventListener('touchstart', this.touchStartHandler);
    
    window.removeEventListener('mousemove', this.mouseMoveHandler);
    this.track.removeEventListener('touchmove', this.touchMoveHandler);
    
    window.removeEventListener('mouseup', this.mouseUpHandler);
    this.track.removeEventListener('touchend', this.touchEndHandler);
    this.track.removeEventListener('mouseleave', this.mouseLeaveHandler);
    
    this.container.removeEventListener('mouseenter', this.mouseEnterHandler);
    this.container.removeEventListener('mouseleave', this.mouseLeaveHandler);
    this.container.removeEventListener('touchstart', this.containerTouchStartHandler);
    this.container.removeEventListener('touchend', this.containerTouchEndHandler);
    
    window.removeEventListener('resize', this.resizeHandler);
  }

  init() {
    this.updateSlidesPerView();

    // Store bound handlers for cleanup
    this.prevClickHandler = () => this.goToSlide(this.currentIndex - 1);
    this.nextClickHandler = () => this.goToSlide(this.currentIndex + 1);
    this.mouseDownHandler = this.touchStart.bind(this);
    this.touchStartHandler = this.touchStart.bind(this);
    this.mouseMoveHandler = this.touchMove.bind(this);
    this.touchMoveHandler = this.touchMove.bind(this);
    this.mouseUpHandler = this.touchEnd.bind(this);
    this.touchEndHandler = this.touchEnd.bind(this);
    this.mouseLeaveHandler = () => {
      if (this.isDragging) {
        this.touchEnd({ type: 'mouseleave' });
      }
    };
    this.mouseEnterHandler = this.stopAutoplay.bind(this);
    this.containerTouchStartHandler = this.stopAutoplay.bind(this);
    this.containerTouchEndHandler = this.resetAutoplay.bind(this);
    this.resizeHandler = this.debouncedResize.bind(this);

    // Add event listeners
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.prevClickHandler);
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.nextClickHandler);
    }
    
    if (this.dots) {
      this.dots.forEach(dot => {
        dot.clickHandler = () => {
          const index = parseInt(dot.dataset.index);
          this.goToSlide(index);
        };
        dot.addEventListener('click', dot.clickHandler);
      });
    }

    // Touch and mouse events
    this.track.addEventListener('mousedown', this.mouseDownHandler);
    this.track.addEventListener('touchstart', this.touchStartHandler, { passive: true });
    
    window.addEventListener('mousemove', this.mouseMoveHandler);
    this.track.addEventListener('touchmove', this.touchMoveHandler, { passive: true });
    
    window.addEventListener('mouseup', this.mouseUpHandler);
    this.track.addEventListener('touchend', this.touchEndHandler);
    this.track.addEventListener('mouseleave', this.mouseLeaveHandler);
    
    // Autoplay control
    this.container.addEventListener('mouseenter', this.mouseEnterHandler);
    this.container.addEventListener('mouseleave', this.containerTouchEndHandler);
    this.container.addEventListener('touchstart', this.containerTouchStartHandler, { passive: true });
    this.container.addEventListener('touchend', this.containerTouchEndHandler);
    
    // Resize handling
    window.addEventListener('resize', this.resizeHandler);

    this.goToSlide(0, false);
    this.startAutoplay();
  }
  
  // Debounce resize for better performance
  debouncedResize() {
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.updateSlidesPerView();
    }, 250);
  }
}

// Slider registry and management
const SFRSliderRegistry = {
  instances: {},
  
  register(id, instance) {
    this.instances[id] = instance;
    return instance;
  },
  
  get(id) {
    return this.instances[id];
  },
  
  remove(id) {
    if (this.instances[id]) {
      this.instances[id].destroy();
      delete this.instances[id];
    }
  },
  
  initializeSlider(container) {
    if (!container || !container.id) return null;
    
    // Clean up existing instance if present
    this.remove(container.id);
    
    // Create and register new instance
    return this.register(
      container.id, 
      new SFRTestimonialSlider(container.id)
    );
  },
  
  initializeAll() {
    document.querySelectorAll('.sfr-container').forEach(container => {
      this.initializeSlider(container);
    });
  }
};

// Document ready and Shopify-specific events
document.addEventListener('DOMContentLoaded', () => {
  SFRSliderRegistry.initializeAll();
});

// Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.sfr-container');
    if (container) {
      SFRSliderRegistry.initializeSlider(container);
    }
  });
  
  document.addEventListener('shopify:section:reorder', () => {
    SFRSliderRegistry.initializeAll();
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('.sfr-container');
    if (container && container.id) {
      SFRSliderRegistry.remove(container.id);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const sliderContainer = event.target.closest('.sfr-container');
    if (!sliderContainer || !sliderContainer.id) return;
    
    const slider = SFRSliderRegistry.get(sliderContainer.id);
    if (!slider) return;
    
    const blockElement = event.target.closest('.sfr-card');
    if (blockElement && blockElement.dataset.index) {
      let slideIndexToGo = parseInt(blockElement.dataset.index);
      if (slider.slidesPerView > 1) {
        slideIndexToGo = Math.max(0, slideIndexToGo - Math.floor(slider.slidesPerView / 2));
      }
      slider.goToSlide(slideIndexToGo);
      slider.stopAutoplay();
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const sliderContainer = event.target.closest('.sfr-container');
    if (sliderContainer && sliderContainer.id) {
      const slider = SFRSliderRegistry.get(sliderContainer.id);
      if (slider) {
        slider.resetAutoplay();
      }
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
